export type GovernmentIdType = 'drivers-license' | 'passport' | 'state-id';

export interface LogisticsData {
  // Insurance data
  insuranceProvider: string;
  memberId: string;
  groupNumber: string;

  // Document uploads (Binary resource URLs)
  governmentIdUrl: string | null;
  governmentIdType: GovernmentIdType;
  insuranceCardFrontUrl: string | null;
  insuranceCardBackUrl: string | null;

  // Pharmacy
  pharmacy: string | null;
}

export interface DocumentUploadState {
  file: File | null;
  preview: string | null;
  binaryId: string | null;
  isUploading: boolean;
  error: string | null;
}

// FHIR document type codes
export const DOCUMENT_TYPE_CODES = {
  'government-id': {
    system: 'http://loinc.org',
    code: '53245-7',
    display: 'Driver license',
  },
  'insurance-card-front': {
    system: 'http://loinc.org',
    code: '64290-0',
    display: 'Health insurance card - front',
  },
  'insurance-card-back': {
    system: 'http://loinc.org',
    code: '64291-8',
    display: 'Health insurance card - back',
  },
} as const;

export type DocumentType = keyof typeof DOCUMENT_TYPE_CODES;
